import React, { FC, useMemo } from 'react';
import { IMappedTempField } from '../../../slice/types';
import { Marker, Polygon } from 'react-leaflet';
import { LeafletEventHandlerFnMap, PathOptions } from 'leaflet';
import { createTempMarker } from '../../../../../components/MarkerIcon/MarkerIcon';
import { useTheme } from 'styled-components';

interface IProps {
  tempPolygon: IMappedTempField;
  isSelected?: boolean;
  eventHandlers?: LeafletEventHandlerFnMap;
}

const TempField: FC<IProps> = ({
  isSelected = false,
  tempPolygon,
  eventHandlers,
}) => {
  const {
    map: { tempField },
  } = useTheme();

  const pathOptions: PathOptions = useMemo(() => {
    const options = {
      fill: true,
      fillColor: tempField.fillColor,
      fillOpacity: 0.7,
      color: tempField.strokeColor,
      opacity: 0.7,
    };

    if (isSelected) {
      options.fillOpacity = 0.9;
      options.opacity = 0.9;
      options.fillColor = tempField.selectedFillColor;
    }

    return options;
  }, [isSelected, tempField]);

  const markerIcon = useMemo(
    () =>
      createTempMarker({
        selected: isSelected,
        background: isSelected
          ? tempField.selectedMarkerColor
          : tempField.markerColor,
      }),
    [isSelected, tempField],
  );

  return (
    <>
      <Polygon
        pathOptions={pathOptions}
        positions={tempPolygon.coordinates}
        eventHandlers={eventHandlers}
      />
      <Marker
        position={tempPolygon.markerPosition}
        eventHandlers={eventHandlers}
        icon={markerIcon}
      />
    </>
  );
};

export default TempField;
